<template>
  <Addition v-if="isAddition">
    <template #field>{{ change.field.name }}</template>
    <div v-for="(item, index) in change.new_value" :key="`${index}_new`">
      <div v-if="item.is_closed" class="special-hours__item">
        <div class="special-hours__date">
          {{ getStartDate({ item, index, type: "new_value" }) }}
        </div>
        <div class="special-hours__state">
          {{ $t("message.common.closed") }}
        </div>
      </div>
      <div v-else class="special-hours__item">
        <div class="special-hours__date">
          {{ getStartDate({ item, index, type: "new_value" }) }}
        </div>
        <div class="special-hours__state">
          {{ getHours(item) }}
        </div>
      </div>
    </div>
  </Addition>
  <Removal v-else-if="isRemoval">
    <template #field>{{ change.field.name }}</template>
    <div v-for="(item, index) in change.old_value" :key="`${index}_old`">
      <div v-if="item.is_closed" class="special-hours__item removed-hours">
        <div class="special-hours__date">
          {{ getStartDate({ item, index, type: "old_value" }) }}
        </div>
        <div class="special-hours__state">
          {{ $t("message.common.closed") }}
        </div>
      </div>
      <div v-else class="special-hours__item removed-hours">
        <div class="special-hours__date">
          {{ getStartDate({ item, index, type: "old_value" }) }}
        </div>
        <div class="special-hours__state">
          {{ getHours(item) }}
        </div>
      </div>
    </div>
  </Removal>
  <Change v-else-if="isChange" class="special-hours">
    <template #field>{{ change.field.name }}</template>
    <template #old>
      <div v-for="(item, index) in change.old_value" :key="`${index}_old`">
        <div v-if="item.is_closed" class="special-hours__item">
          <div class="special-hours__date">
            {{ getStartDate({ item, index, type: "old_value" }) }}
          </div>
          <div class="special-hours__state">
            {{ $t("message.common.closed") }}
          </div>
        </div>
        <div v-else class="special-hours__item">
          <div class="special-hours__date">
            {{ getStartDate({ item, index, type: "old_value" }) }}
          </div>
          <div class="special-hours__state">
            {{ getHours(item) }}
          </div>
        </div>
      </div>
    </template>
    <template #new>
      <div v-for="(item, index) in change.new_value" :key="`${index}_new`">
        <div v-if="item.is_closed" class="special-hours__item">
          <div class="special-hours__date">
            {{ getStartDate({ item, index, type: "new_value" }) }}
          </div>
          <div class="special-hours__state">
            {{ $t("message.common.closed") }}
          </div>
        </div>
        <div v-else class="special-hours__item">
          <div class="special-hours__date">
            {{ getStartDate({ item, index, type: "new_value" }) }}
          </div>
          <div class="special-hours__state">
            {{ getHours(item) }}
          </div>
        </div>
      </div>
    </template>
  </Change>
</template>

<script>
import moment from "moment";
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";
import { FORMAT } from "@/config/date-format";

import Addition from "@/components/ExternalChanges/general/Addition.vue";
import Removal from "@/components/ExternalChanges/general/Removal.vue";
import Change from "@/components/ExternalChanges/general/Change.vue";

export default {
  name: "SpecialOpeningHoursChange",
  components: { Addition, Removal, Change },

  props: {
    change: {
      type: Object,
      required: true
    }
  },

  computed: {
    isAddition() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.ADDITION &&
            this.change.new_value
        : false;
    },
    isRemoval() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.REMOVAL &&
            this.change.old_value
        : false;
    },
    isChange() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.CHANGE &&
            this.change.new_value &&
            this.change.old_value
        : false;
    }
  },

  methods: {
    getStartDateLabel(item) {
      return moment({
        ...item.start_date,
        month: item.start_date.month - 1
      }).format(FORMAT.DATE);
    },
    getStartDate({ item, index, type }) {
      if (index === 0) {
        return this.getStartDateLabel(item);
      } else {
        const previousLabel = this.getStartDateLabel(
          this.change[type][index - 1]
        );
        const currentLabel = this.getStartDateLabel(item);

        return previousLabel === currentLabel ? "" : currentLabel;
      }
    },
    getHours(item) {
      return `${item.open_time} - ${item.close_time}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.special-hours {
  &__item {
    display: flex;
  }

  &__date {
    width: 50%;
    min-width: max-content;
    margin-right: $spacing * 3;
  }

  &__state {
    width: 50%;
    min-width: max-content;
    opacity: 0.6;
  }
}

.removed-hours {
  text-decoration: line-through;
}
</style>
